import type { ReactNode } from 'react';

import { css, styled } from 'styled-components';

type HeadingTypes = 'h1' | 'h2' | 'h3' | 'h4';

type HeadingSCProps = {
  $uppercase?: boolean;
  as?: HeadingTypes;
};

const h1 = css`
  line-height: 2.875rem;
  font-size: 2rem;
`;

const h2 = css`
  line-height: 2rem;
  font-size: 1.625rem;
`;

const h3 = css`
  line-height: 1.375rem;
  font-size: 1.125rem;
`;

const h4 = css`
  line-height: 1rem;
  font-size: 0.875rem;
`;

const HeadingSC = styled.h1<HeadingSCProps>`
  font-weight: 600;
  margin: 0;

  ${(props) => {
    switch (props.as) {
      case 'h2':
        return h2;
      case 'h3':
        return h3;
      case 'h4':
        return h4;
      case 'h1':
      default:
        return h1;
    }
  }}

  text-transform: ${(props) => (props.$uppercase ? 'uppercase' : 'none')};
`;

export type Props = HeadingSCProps & {
  children: ReactNode;
  className?: string;
};

export const Heading = ({ children, ...rest }: Props) => {
  return <HeadingSC {...rest}>{children}</HeadingSC>;
};
